var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('h1',{staticClass:"content"},[_vm._v("アカウントの権限がありませんですので、管理者にご連絡してください。")])])])
}]

export { render, staticRenderFns }